import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';

const { domain } = shopifyConst;

// 获取shoipy 国家数据
export const useCountryData = async () => {
	return await useScrmFetch(`/api/gws-ext/shop/countries?endpoint=${domain}`).post().json();
}

// 获取shoipy 省份数据
export const useProvinceData = async (countryId,lang) => {
	return await useScrmFetch(`/api/gws-ext/shop/provinces?endpoint=${domain}`).post({
		countryId,
		lang
	}).json();
}
